import { api, apiFetchFormData } from "../utils/api";
import type { RestReseller } from "@KassaroAB/shared/types/reseller";
import type { ResellerId } from "@KassaroAB/shared/types/ids";

export const getResellersApi = async (): Promise<RestReseller[]> => {
  return api.get(`resellers`);
};

export const getResellersPaginatedApi = async (cursor: string | null, limit: number = 20): Promise<RestReseller[]> => {
  const params = new URLSearchParams();
  if (cursor) {
    params.set('cursor', cursor);
  }
  params.set('limit', limit.toString());
  return api.get(`resellers?${params.toString()}`);
};

export const getResellerApi = async (resellerId: ResellerId): Promise<RestReseller> => {
  return api.get(`resellers/${resellerId}`);
};

export const createResellerApi = async (formData: FormData): Promise<RestReseller> => {
  return apiFetchFormData("resellers", {
    method: "POST",
    body: formData,
  }) as Promise<RestReseller>;
};

export const updateResellerApi = async (
  resellerId: ResellerId,
  formData: FormData
): Promise<RestReseller> => {
  return apiFetchFormData(`resellers/${resellerId}`, {
    method: "PUT",
    body: formData,
  }) as Promise<RestReseller>;
};

export const updateResellerPartialApi = async (
  resellerId: ResellerId,
  reseller: Partial<{
    brand?: string;
  }>
): Promise<RestReseller> => {
  return api.put(`resellers/${resellerId}`, reseller);
};
